module.exports = __webpack_public_path__ + "fonts/632eeeb1-e81b-472c-87cc-6ec84f44c7b2.ffd0ffda.woff";